module.exports = __webpack_public_path__ + "img/closeIcon.8f307f2d.svg";